import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { FlexContainer, TitleH1, Paragraph, PureSpinner } from 'heliocor-ui'
import 'styled-components/macro'

import { ActionsWrapper } from '../Camera.elements';
import { ButtonRec, ButtonRecBorder, CountdownSection, CountdownContainer, CountdownNumber } from './VideoSelfie.styles'

const RecButton = ({ onClick }) =>
    <ButtonRecBorder type='REC'>
        <ButtonRec onClick={onClick} type='REC' />
    </ButtonRecBorder>

const DisconnectedView = () => <FlexContainer alignItems='center' justifyContent='center' width='360px' height='192px' backgroundColor='grey700' />

const STATEMENT_START_COUNTDOWN_SECONDS = 6

const VideoActionsView = ({ isTabActive, handleRecordClick, onStartRecording, message, actionView, onStatementCheckStart, videoDuration }) => {
    const { t } = useTranslation()
    const [seconds, setSeconds] = useState(3)
    const [timerIsActive, setTimerIsActive] = useState(false)

    useEffect(() => {
        if(actionView !== 'countdown' && actionView !== 'statementCheckCountdown') {
            return
        }
        let interval
        if (timerIsActive) {
            interval = setInterval(() => {
                setSeconds(seconds => seconds - 1)
            }, 1000)
        } else {
            interval && clearInterval(interval)
        }
        
        return () => clearInterval(interval)
    }, [timerIsActive, actionView])

    useEffect(() => {
        if (seconds === 0) {
            actionView === 'countdown' && onStartRecording()
            actionView === 'statementCheckCountdown' && onStatementCheckStart()
            setTimerIsActive(false)
            setSeconds(3)
        }
    }, [seconds])

    useEffect(() => {
        if (actionView === 'countdown' || actionView === 'statementCheckCountdown') {
            actionView === 'statementCheckCountdown' && setSeconds(STATEMENT_START_COUNTDOWN_SECONDS)
            setTimerIsActive(true)
        }
    }, [actionView])

    useEffect(() => {
        if(!isTabActive) {
            setTimerIsActive(false)
            setSeconds(3)
        }
    }, [isTabActive])

    const getActionView = () => {
        switch (actionView) {
            case 'startRecording':
                return <RecButton onClick={handleRecordClick} />
            case 'countdown':
            case 'statementCheckCountdown':
                return <TitleH1 color='white' value={seconds} />
            case 'sending':
            case 'finished':
                return <FlexContainer><PureSpinner color='grey500'/></FlexContainer>
            default:
                return null
        }
    }

    return (
        <ActionsWrapper>
            <FlexContainer column alignItems='center'>
                <FlexContainer
                    backgroundColor='main'
                    width='auto'
                    padding='.45rem'
                    justifyContent='center'
                    css='position:absolute; top:0; left: 0; right: 0; text-align: center;'
                >
                    <Paragraph
                        color='white'
                        margin='0 .25rem'
                        value={t(message, {time: Math.round(videoDuration/1000)})}
                    />
                </FlexContainer>
                {getActionView()}
            </FlexContainer>
        </ActionsWrapper>
    )
}

const VideoActions = React.memo(VideoActionsView)

const StatementCountdown = ({ maxSeconds, countdownSeconds }) => {
    const [seconds, setSeconds] = useState()

    const getContent = () => {
        return [...Array(maxSeconds).keys()]
            .map(i => i < 10 ? `0${i}` : i)
            .join('\\a ')
            .replace('00', '✓')
    }

    useEffect(() => setSeconds(countdownSeconds), [countdownSeconds])

    useEffect(() => {
        let timeout;
        timeout = seconds && setTimeout(() => setSeconds(seconds - 1), 1000)
        return () => timeout && clearTimeout(timeout)
    }, [seconds])

    return countdownSeconds && (
        <CountdownContainer>
            <CountdownSection>
                <CountdownNumber
                    content={getContent()}
                    seconds={isNaN(seconds) ? countdownSeconds : seconds}
                />
            </CountdownSection>
        </CountdownContainer>
    )
}

export {
    STATEMENT_START_COUNTDOWN_SECONDS,
    ActionsWrapper,
    DisconnectedView,
    StatementCountdown,
    VideoActions
}